import { CASE_STATUS, STATUS_DESCRIPTIONS, STATUS_NAMES } from "@/constants";

import type { CaseStatusLegendRow } from "../CaseStatusHelpLegendView";

const STATUS_LEGEND_ORDER: (keyof typeof STATUS_DESCRIPTIONS)[] = [
  CASE_STATUS.ERROR,
  CASE_STATUS.DRAFT,
  CASE_STATUS.AI_REVIEW,
  CASE_STATUS.HUMAN_REVIEW,
  CASE_STATUS.FINISHED,
  CASE_STATUS.ARCHIVED,
];

export function buildCaseStatusLegendRows(): CaseStatusLegendRow[] {
  return STATUS_LEGEND_ORDER.map((statusId) => ({
    key: String(statusId),
    label: STATUS_NAMES[statusId],
    description: STATUS_DESCRIPTIONS[statusId],
  }));
}
